var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      staticClass: "rounded v-application",
      attrs: { outlined: "", elevation: "0" },
    },
    [
      _c("v-card-title", [_vm._v("Organisatorisches")]),
      _vm._v(" "),
      _c("v-divider"),
      _vm._v(" "),
      _c("v-card-text", { staticClass: "mt-5 pb-1" }, [
        _vm.pharmacy.parking
          ? _c("p", [
              _c("strong", [_vm._v("Parkplatz: ")]),
              _vm._v(_vm._s(_vm.pharmacy.pretty_parking) + "\n        "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.pharmacy.public_transport
          ? _c("p", [
              _c("strong", [_vm._v("ÖPNV: ")]),
              _vm._v(" "),
              _vm.pharmacy.public_transport.closest_stop
                ? _c("span", [
                    _vm._v(
                      "\n                Nächste Haltestelle: " +
                        _vm._s(_vm.pharmacy.public_transport["closest_stop"]) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.pharmacy.public_transport.distance_to_train_station
                ? _c("span", [
                    _vm._v(
                      "\n                    Entfernung zum nächsten Hbf: " +
                        _vm._s(
                          _vm.pharmacy.public_transport[
                            "distance_to_train_station"
                          ]
                        ) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.pharmacy.clothing
          ? _c("p", [
              _c("strong", [_vm._v("Kleidung: ")]),
              _vm._v(_vm._s(_vm.pharmacy.pretty_clothing) + "\n            "),
              _vm.pharmacy.clothing == "1"
                ? _c("span", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.pharmacy.clothing_color) +
                        "\n            "
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.pharmacy.surroundings
          ? _c("p", [
              _c("strong", [_vm._v("APO-Typ: ")]),
              _vm._v(_vm._s(_vm.pharmacy.pretty_surroundings) + "\n        "),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }